var map = {
	"./biblio.png": 52,
	"./github.png": 4,
	"./githubw.png": 15,
	"./logo.png": 3,
	"./nodejs.png": 11,
	"./prism.png": 53,
	"./sketch.png": 9,
	"./spartanconnect.png": 54,
	"./swishbox.png": 55,
	"./vscode.png": 8,
	"./vue.png": 10
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 51;


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*$
// module id = 51
// module chunks = 0